// Dashboard "Jumlah Pasien per Hari": GET /dashboard/harian only returns dates that have patients, so a day without
// any (e.g. a Sunday) vanished from the axis. Fill those days with a 0 bar, but only while the span from the first to
// the last date is at most MAX_FILLED_DAYS days (both ends counted); longer spans are shown as returned. No imports,
// so the Jest test runs without the "@/" alias.

export const MAX_FILLED_DAYS = 62;
const DAY_MS = 24 * 60 * 60 * 1000;

const toUtc = (t) => Date.UTC(Number(t.slice(0, 4)), Number(t.slice(5, 7)) - 1, Number(t.slice(8, 10)));
const toStr = (ms) => new Date(ms).toISOString().slice(0, 10);

// rows: [{ tanggal: "YYYY-MM-DD", jumlah }] sorted by tanggal -> same rows plus { tanggal, jumlah: 0 } for missing days.
export function fillDailyGaps(rows, maxDays = MAX_FILLED_DAYS) {
  if (rows.length < 2 || !rows.every((r) => /^\d{4}-\d{2}-\d{2}$/.test(r.tanggal || ""))) return rows;
  const first = toUtc(rows[0].tanggal);
  const days = Math.round((toUtc(rows[rows.length - 1].tanggal) - first) / DAY_MS) + 1;
  if (days > maxDays || days <= rows.length) return rows;
  const byDate = new Map(rows.map((r) => [r.tanggal, r]));
  return Array.from({ length: days }, (_, i) => {
    const tanggal = toStr(first + i * DAY_MS);
    return byDate.get(tanggal) || { tanggal, jumlah: 0 };
  });
}
